import TabCards from 'common/components/TabCards';
import React, { useState } from 'react';
import styled from 'styled-components';
import OrganizationGoalDetailsModal from './OrganizationGoalDetailsModal';
import { Icon } from 'semantic-ui-react';
import { GoalCardData } from '../interfaces/OrganizationGoalInterfaces';

interface SelectGoalCardProps {
  goalCardData: GoalCardData[];
  setSelectedGoal: (value: number) => void;
  activeGoalId: number | null;
}

const SelectGoalCard: React.FC<SelectGoalCardProps> = ({
  goalCardData,
  setSelectedGoal,
  activeGoalId,
}) => {
  const selectedTabCard = goalCardData.findIndex(goal => goal.key === activeGoalId);

  const selectGoal = (tabId: number) => {
    setSelectedGoal(goalCardData[tabId].key);
  };

  const [selectedItem, setSelectedItem] = useState<any | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = (item: any) => {
    setSelectedItem(item);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectedItem(null);
    setIsModalOpen(false);
  };

  return (
    <Container>
      <TabCards
        onSelect={(item: number) => selectGoal(item)}
        selected={selectedTabCard}
        options={goalCardData.slice().map(item => (
          <Column key={item.key}>
            <Card key={item.key}>
              <Header>{item.header}</Header>
              <CardBodyText title={item.bodyText}>
                {item.bodyText.length > 200 ? `${item.bodyText.slice(0, 200)}...` : item.bodyText}{' '}
                &nbsp;
                <IconWrapper
                  onClick={e => {
                    e.stopPropagation();
                    handleOpenModal(item);
                  }}
                >
                  [<Icon name="external alternate" color="grey" size="small" />
                  more]
                </IconWrapper>
              </CardBodyText>
            </Card>
          </Column>
        ))}
      />
      <OrganizationGoalDetailsModal
        title={selectedItem?.header}
        details={selectedItem?.bodyText}
        context={selectedItem?.context}
        handleCloseModal={handleCloseModal}
        isModalOpen={isModalOpen}
      />
    </Container>
  );
};
export default SelectGoalCard;

const Container = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
`;

const Column = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 15px;
  gap: 10px;
`;

const Header = styled.h2`
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  font-weight: 500;
  font-style: normal;
  color: #414141;
  margin-bottom: 5px;
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
`;

const CardBodyText = styled.div`
  font-size: 12px;
  color: #555;
  line-height: 1.5;
  max-height: '500px';
  overflow: hidden;
  transition:
    max-height 1s ease-in-out,
    opacity 0.2s ease-in-out,
    visibility 0.6s ease-in-out;
`;

const IconWrapper = styled.span`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
`;
